import React from 'react';
import Synonyms from './Synonyms';
import Examples from './Examples';
import './Meaning.css';

export default function Meaning(props) {
  return (
    <div className="Meaning">
      <h2>{props.meaning.partOfSpeech}</h2>
      {props.meaning.definitions.map(function (definition, index) {
        return (
          <div key={index}>
            <p>
              <strong className="Definition">Definition: </strong>
              {definition.definition}
              <br />
              <Examples example={definition.example} />
              <Synonyms synonyms={definition.synonyms} />
            </p>
          </div>
        );
      })}
    </div>
  );
}
